<template>
    <div class="w-3/6 m-auto">
        <div class="mb-4 text-sm text-gray-600">
            <!-- Thanks for signing up! Before getting started, could you verify your email address by clicking on the link we just emailed to you? If you didn't receive the email, we will gladly send you another. -->
            {{ __('thanks_for_signinup') }}
        </div>

        <div class="mb-4 font-medium text-sm text-green-600" v-if="verificationLinkSent" >
            <!-- A new verification link has been sent to the email address you provided during registration. -->
            {{ __('new_verification_link_sent') }}
        </div>

        <form @submit.prevent="submit">
            <div class="mt-4 flex items-center justify-between">
                <breeze-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                    {{ __('resend_verification_email') }}
                </breeze-button>

                <inertia-link :href="route('logout')" method="post" as="button" class="underline text-sm text-gray-600 hover:text-gray-900">Log Out</inertia-link>
            </div>
        </form>
    </div>
</template>

<script>
    import BreezeButton from '@/Components/Button'
    import App from "@/Layouts/App"

    export default {
        layout: App,

        components: {
            BreezeButton,
        },

        props: {
            status: String
        },

        data() {
            return {
                form: this.$inertia.form()
            }
        },

        methods: {
            submit() {
                this.form.post(this.route('verification.send'))
            },
        },

        computed: {
            verificationLinkSent() {
                return this.status === 'verification-link-sent';
            }
        }
    }
</script>
